// import React, { useState, useEffect } from 'react'
// import * as styles from "./ProjectStatus.module.scss";
// import statusImage1 from "../../../images/on-going-projects/srinivasa/project-status/sept-2025/1.jpg";
// import statusImage2 from "../../../images/on-going-projects/srinivasa/project-status/sept-2025/2.jpg";
// import statusImage3 from "../../../images/on-going-projects/srinivasa/project-status/sept-2025/3.jpg";
// import statusImage4 from "../../../images/on-going-projects/srinivasa/project-status/sept-2025/4.jpg";
// import statusImage5 from "../../../images/on-going-projects/srinivasa/project-status/sept-2025/5.jpg";
// import statusImage6 from "../../../images/on-going-projects/srinivasa/project-status/sept-2025/6.jpg";

// import statusImageNov1 from "../../../images/on-going-projects/srinivasa/project-status/november-2025/1.jpeg";
// import statusImageNov2 from "../../../images/on-going-projects/srinivasa/project-status/november-2025/2.jpg";
// import statusImageNov3 from "../../../images/on-going-projects/srinivasa/project-status/november-2025/3.jpg";
// import statusImageNov4 from "../../../images/on-going-projects/srinivasa/project-status/november-2025/4.jpg";
// import statusImageNov5 from "../../../images/on-going-projects/srinivasa/project-status/november-2025/5.jpg";
// import statusImageNov6 from "../../../images/on-going-projects/srinivasa/project-status/november-2025/6.jpg";
// import statusImageNov7 from "../../../images/on-going-projects/srinivasa/project-status/november-2025/7.jpg";

// import statusImageDec1 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/1.jpg";
// import statusImageDec2 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/2.jpg";
// import statusImageDec3 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/3.jpg";
// import statusImageDec4 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/4.jpg";
// import statusImageDec5 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/5.jpg";
// import statusImageDec6 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/6.jpg";
// import statusImageDec7 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/7.jpg";
// import statusImageDec8 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/8.jpg";
// import statusImageDec9 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/9.jpg";
// import statusImageDec10 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/10.jpg";
// import statusImageDec11 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/11.jpg";
// import statusImageDec12 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/12.jpg";

// import statusImageJan1 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-1.jpeg";
// import statusImageJan2 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-2.jpeg";
// import statusImageJan3 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-3.jpeg";
// import statusImageJan4 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-4.jpeg";
// import statusImageJan5 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-5.jpeg";
// import statusImageJan6 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-6.jpeg";
// import statusImageJan7 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-7.jpeg";
// import statusImageJan8 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-8.jpeg";
// import statusImageJan9 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-9.jpeg";
// import statusImageJan10 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-10.jpeg";
// import statusImageJan11 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-11.jpeg";


// import bgImage from "../../../images/on-going-projects/srinivasa/header-icon.png";
// import ImageModal from "../enchanted/ImageModal";
// import { RightCircleFilled, LeftCircleFilled } from '@ant-design/icons';

// function ProjectStatus() {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [projectStatusImages, setProjectStatusImages] = useState([statusImageJan1, statusImageJan2, statusImageJan3, statusImageJan4, statusImageJan5, statusImageJan6, statusImageJan7, statusImageJan8, statusImageJan9, statusImageJan10, statusImageJan11]);
//   const [activeImageMobile, setActiveImageMobile] = useState(0);
//   const [activeMonthIndex, setActiveMonthIndex] = useState(0);

//   useEffect(() => {
//     if (activeMonthIndex === 0) {
//       setProjectStatusImages([statusImageJan1, statusImageJan2, statusImageJan3, statusImageJan4, statusImageJan5, statusImageJan6, statusImageJan7, statusImageJan8, statusImageJan9, statusImageJan10, statusImageJan11]);
//       setActiveImageMobile(0);

//     }
//     else if (activeMonthIndex === 1) {
//       setProjectStatusImages([statusImageDec1, statusImageDec2, statusImageDec3, statusImageDec4, statusImageDec5, statusImageDec6, statusImageDec7, statusImageDec8, statusImageDec9, statusImageDec10, statusImageDec11, statusImageDec12]);
//       setActiveImageMobile(0);
//     }
//     else if (activeMonthIndex === 2) {
//       setProjectStatusImages([statusImageNov1, statusImageNov2, statusImageNov3, statusImageNov4, statusImageNov5, statusImageNov6, statusImageNov7]);
//       setActiveImageMobile(0);
//     }
//     else {
//       setProjectStatusImages([statusImage1, statusImage2, statusImage3, statusImage4, statusImage5, statusImage6]);
//       setActiveImageMobile(0);
//     }
//   }, [activeMonthIndex]);

//   function prevSlideMobile() {
//     if (activeImageMobile > 0) {
//       setActiveImageMobile((prev) => prev - 1);
//     }
//   }

//   function nextSlideMobile() {
//     if (activeImageMobile < 5) {
//       setActiveImageMobile((prev) => prev + 1);
//     }
//   }

//   function prevSlideMonth() {
//     if (activeMonthIndex > 0) {
//       setActiveMonthIndex((prev) => prev - 1);
//     }
//   }

//   function nextSlideMonth() {
//     if (activeMonthIndex < 3) {
//       setActiveMonthIndex((prev) => prev + 1);
//     }
//   }

//   return (
//     <div className={styles.projectStatus} id="section-6">
//       <div className={styles.heading}>
//         <img src={bgImage} alt="Project Status" className={styles.bgImage} />
//         <span>Project Status</span></div>
//       <div style={{ position: 'relative' }}>
//         {/* <div className={styles.arrowContainerMobile}> */}
//         {<LeftCircleFilled style={{ opacity: activeImageMobile > 0 ? '1' : '0' }} className={styles.arrowMobile + ' ' + styles.arrowMobileLeft} onClick={() => { activeImageMobile > 0 && prevSlideMobile(); }} />}
//         {<RightCircleFilled style={{ opacity: activeImageMobile < 5 ? '1' : '0' }} className={styles.arrowMobile + ' ' + styles.arrowMobileRight} onClick={() => { activeImageMobile < 5 && nextSlideMobile(); }} />}
//         {/* </div> */}
//         {/* <div className={styles.arrowContainerWeb}> */}
//         {<LeftCircleFilled style={{ opacity: activeMonthIndex > 0 ? '1' : '0' }} className={styles.arrowWeb + ' ' + styles.arrowWebLeft} onClick={() => { prevSlideMonth(); }} />}
//         {<RightCircleFilled style={{ opacity: activeMonthIndex < 3 ? '1' : '0' }} className={styles.arrowWeb + ' ' + styles.arrowWebRight} onClick={() => { nextSlideMonth(); }} />}
//         {/* </div> */}
//         <div className={styles.projectStatusContent}>
//           <div className={styles.projectStatusContentItem} style={{ transform: `translateX(${activeMonthIndex * 100 * -1}%)`, transition: 'all 0.5s ease' }}>
//             <span className={styles.projectStatusHeading}>January</span>
//             <div className={styles.projectStatusContentContainer}>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageJan1} alt="status-image" onClick={() => {
//                   setSelectedImage(1);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageJan2} alt="status-image" onClick={() => {
//                   setSelectedImage(2);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageJan3} alt="status-image" onClick={() => {
//                   setSelectedImage(3);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageJan4} alt="status-image" onClick={() => {
//                   setSelectedImage(4);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageJan5} alt="status-image" onClick={() => {
//                   setSelectedImage(5);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageJan6} alt="status-image" onClick={() => {
//                   setSelectedImage(6);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageJan7} alt="status-image" onClick={() => {
//                   setSelectedImage(7);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageJan8} alt="status-image" onClick={() => {
//                   setSelectedImage(8);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageJan9} alt="status-image" onClick={() => {
//                   setSelectedImage(9);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageJan10} alt="status-image" onClick={() => {
//                   setSelectedImage(10);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageJan11} alt="status-image" onClick={() => {
//                   setSelectedImage(11);
//                   setIsModalOpen(true);
//                 }} />
//               </div>

//             </div>
//           </div>


//           <div className={styles.projectStatusContentItem} style={{ transform: `translateX(${activeMonthIndex * 100 * -1}%)`, transition: 'all 0.5s ease' }}>
//             <span className={styles.projectStatusHeading}>December</span>
//             <div className={styles.projectStatusContentContainer}>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageDec1} alt="status-image" onClick={() => {
//                   setSelectedImage(1);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageDec2} alt="status-image" onClick={() => {
//                   setSelectedImage(2);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageDec3} alt="status-image" onClick={() => {
//                   setSelectedImage(3);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageDec4} alt="status-image" onClick={() => {
//                   setSelectedImage(4);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageDec5} alt="status-image" onClick={() => {
//                   setSelectedImage(5);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageDec6} alt="status-image" onClick={() => {
//                   setSelectedImage(6);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageDec7} alt="status-image" onClick={() => {
//                   setSelectedImage(7);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageDec8} alt="status-image" onClick={() => {
//                   setSelectedImage(8);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageDec9} alt="status-image" onClick={() => {
//                   setSelectedImage(9);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageDec10} alt="status-image" onClick={() => {
//                   setSelectedImage(10);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageDec11} alt="status-image" onClick={() => {
//                   setSelectedImage(11);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageDec12} alt="status-image" onClick={() => {
//                   setSelectedImage(12);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//             </div>
//           </div>
//           <div className={styles.projectStatusContentItem} style={{ transform: `translateX(${activeMonthIndex * 100 * -1}%)`, transition: 'all 0.5s ease' }}>
//             <span className={styles.projectStatusHeading}>November</span>
//             <div className={styles.projectStatusContentContainer}>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageNov1} alt="status-image" onClick={() => {
//                   setSelectedImage(1);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageNov2} alt="status-image" onClick={() => {
//                   setSelectedImage(2);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageNov3} alt="status-image" onClick={() => {
//                   setSelectedImage(3);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageNov4} alt="status-image" onClick={() => {
//                   setSelectedImage(4);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageNov5} alt="status-image" onClick={() => {
//                   setSelectedImage(5);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageNov6} alt="status-image" onClick={() => {
//                   setSelectedImage(6);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImageNov7} alt="status-image" onClick={() => {
//                   setSelectedImage(7);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//             </div>
//           </div>
//           <div className={styles.projectStatusContentItem} style={{ transform: `translateX(${activeMonthIndex * 100 * -1}%)`, transition: 'all 0.5s ease' }}>
//             <span className={styles.projectStatusHeading}>September</span>
//             <div className={styles.projectStatusContentContainer}>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImage1} alt="status-image" onClick={() => {
//                   setSelectedImage(1);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImage2} alt="status-image" onClick={() => {
//                   setSelectedImage(2);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImage3} alt="status-image" onClick={() => {
//                   setSelectedImage(3);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImage4} alt="status-image" onClick={() => {
//                   setSelectedImage(4);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImage5} alt="status-image" onClick={() => {
//                   setSelectedImage(5);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//               <div style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }} className={styles.projectStatusContentItem}>
//                 <img src={statusImage6} alt="status-image" onClick={() => {
//                   setSelectedImage(6);
//                   setIsModalOpen(true);
//                 }} />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {isModalOpen ? (
//         <ImageModal
//           imagesArray={projectStatusImages}
//           selectedImage={selectedImage}
//           setSelectedImage={setSelectedImage}
//           showModal={isModalOpen}
//           setShowModal={setIsModalOpen}
//         />
//       ) : null}
//     </div>
//   )
// }

// export default ProjectStatus



import React, { useState, useEffect } from 'react'
import * as styles from "./ProjectStatus.module.scss";

// September
import statusImage1 from "../../../images/on-going-projects/srinivasa/project-status/sept-2025/1.jpg";
import statusImage2 from "../../../images/on-going-projects/srinivasa/project-status/sept-2025/2.jpg";
import statusImage3 from "../../../images/on-going-projects/srinivasa/project-status/sept-2025/3.jpg";
import statusImage4 from "../../../images/on-going-projects/srinivasa/project-status/sept-2025/4.jpg";
import statusImage5 from "../../../images/on-going-projects/srinivasa/project-status/sept-2025/5.jpg";
import statusImage6 from "../../../images/on-going-projects/srinivasa/project-status/sept-2025/6.jpg";

// November
import statusImageNov1 from "../../../images/on-going-projects/srinivasa/project-status/november-2025/1.jpeg";
import statusImageNov2 from "../../../images/on-going-projects/srinivasa/project-status/november-2025/2.jpg";
import statusImageNov3 from "../../../images/on-going-projects/srinivasa/project-status/november-2025/3.jpg";
import statusImageNov4 from "../../../images/on-going-projects/srinivasa/project-status/november-2025/4.jpg";
import statusImageNov5 from "../../../images/on-going-projects/srinivasa/project-status/november-2025/5.jpg";
import statusImageNov6 from "../../../images/on-going-projects/srinivasa/project-status/november-2025/6.jpg";
import statusImageNov7 from "../../../images/on-going-projects/srinivasa/project-status/november-2025/7.jpg";

// December
import statusImageDec1 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/1.jpg";
import statusImageDec2 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/2.jpg";
import statusImageDec3 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/3.jpg";
import statusImageDec4 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/4.jpg";
import statusImageDec5 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/5.jpg";
import statusImageDec6 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/6.jpg";
import statusImageDec7 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/7.jpg";
import statusImageDec8 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/8.jpg";
import statusImageDec9 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/9.jpg";
import statusImageDec10 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/10.jpg";
import statusImageDec11 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/11.jpg";
import statusImageDec12 from "../../../images/on-going-projects/srinivasa/project-status/december-2025/12.jpg";

// January
import statusImageJan1 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-1.jpeg";
import statusImageJan2 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-2.jpeg";
import statusImageJan3 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-3.jpeg";
import statusImageJan4 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-4.jpeg";
import statusImageJan5 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-5.jpeg";
import statusImageJan6 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-7.jpeg";
import statusImageJan7 from "../../../images/on-going-projects/srinivasa/project-status/january-2026/Srinivasa-9.jpeg";

// February
import statusImageFeb1 from "../../../images/on-going-projects/srinivasa/project-status/February-2026/1.jpg";
import statusImageFeb2 from "../../../images/on-going-projects/srinivasa/project-status/February-2026/2.jpg";
import statusImageFeb3 from "../../../images/on-going-projects/srinivasa/project-status/February-2026/3.jpg";
import statusImageFeb4 from "../../../images/on-going-projects/srinivasa/project-status/February-2026/4.jpg";
import statusImageFeb5 from "../../../images/on-going-projects/srinivasa/project-status/February-2026/5.jpg";
import statusImageFeb6 from "../../../images/on-going-projects/srinivasa/project-status/February-2026/6.jpg";
import statusImageFeb7 from "../../../images/on-going-projects/srinivasa/project-status/February-2026/7.jpg";
import statusImageFeb8 from "../../../images/on-going-projects/srinivasa/project-status/February-2026/8.jpg";
import statusImageFeb9 from "../../../images/on-going-projects/srinivasa/project-status/February-2026/9.jpg";
import statusImageFeb10 from "../../../images/on-going-projects/srinivasa/project-status/February-2026/10.jpg";
import statusImageFeb11 from "../../../images/on-going-projects/srinivasa/project-status/February-2026/11.jpg";
import statusImageFeb12 from "../../../images/on-going-projects/srinivasa/project-status/February-2026/12.jpg";
import statusImageFeb13 from "../../../images/on-going-projects/srinivasa/project-status/February-2026/13.jpg";
import statusImageFeb14 from "../../../images/on-going-projects/srinivasa/project-status/February-2026/14.jpg";
import statusImageFeb15 from "../../../images/on-going-projects/srinivasa/project-status/February-2026/15.jpg";

// March
import statusImageMar1 from "../../../images/on-going-projects/srinivasa/project-status/March-2026/1.jpeg";
import statusImageMar2 from "../../../images/on-going-projects/srinivasa/project-status/March-2026/2.jpeg";
import statusImageMar3 from "../../../images/on-going-projects/srinivasa/project-status/March-2026/3.jpeg";
import statusImageMar4 from "../../../images/on-going-projects/srinivasa/project-status/March-2026/4.jpeg";
import statusImageMar5 from "../../../images/on-going-projects/srinivasa/project-status/March-2026/5.jpeg";
import statusImageMar6 from "../../../images/on-going-projects/srinivasa/project-status/March-2026/6.jpeg";
import statusImageMar7 from "../../../images/on-going-projects/srinivasa/project-status/March-2026/7.jpeg";
import statusImageMar8 from "../../../images/on-going-projects/srinivasa/project-status/March-2026/8.jpeg";
import statusImageMar9 from "../../../images/on-going-projects/srinivasa/project-status/March-2026/9.jpeg";
import statusImageMar10 from "../../../images/on-going-projects/srinivasa/project-status/March-2026/10.jpeg";

// April
import statusImageApr1 from "../../../images/on-going-projects/srinivasa/project-status/April-2026/1.jpeg";
import statusImageApr2 from "../../../images/on-going-projects/srinivasa/project-status/April-2026/2.jpeg";
import statusImageApr3 from "../../../images/on-going-projects/srinivasa/project-status/April-2026/3.jpeg";
import statusImageApr4 from "../../../images/on-going-projects/srinivasa/project-status/April-2026/4.jpeg";
import statusImageApr5 from "../../../images/on-going-projects/srinivasa/project-status/April-2026/5.jpeg";

// May
import statusImageMay1 from "../../../images/on-going-projects/srinivasa/project-status/May-2026/1.jpeg";
import statusImageMay2 from "../../../images/on-going-projects/srinivasa/project-status/May-2026/2.jpeg";
import statusImageMay3 from "../../../images/on-going-projects/srinivasa/project-status/May-2026/3.jpeg";
import statusImageMay4 from "../../../images/on-going-projects/srinivasa/project-status/May-2026/4.jpeg";
import statusImageMay5 from "../../../images/on-going-projects/srinivasa/project-status/May-2026/5.jpeg";
import statusImageMay6 from "../../../images/on-going-projects/srinivasa/project-status/May-2026/6.jpeg";
import statusImageMay7 from "../../../images/on-going-projects/srinivasa/project-status/May-2026/7.jpeg";
import statusImageMay8 from "../../../images/on-going-projects/srinivasa/project-status/May-2026/8.jpeg";

// June
import statusImageJun1 from "../../../images/on-going-projects/srinivasa/project-status/June-2026/1.jpeg";
import statusImageJun2 from "../../../images/on-going-projects/srinivasa/project-status/June-2026/2.jpeg";
import statusImageJun3 from "../../../images/on-going-projects/srinivasa/project-status/June-2026/3.jpeg";
import statusImageJun4 from "../../../images/on-going-projects/srinivasa/project-status/June-2026/4.jpeg";
import statusImageJun5 from "../../../images/on-going-projects/srinivasa/project-status/June-2026/5.jpeg";
import statusImageJun6 from "../../../images/on-going-projects/srinivasa/project-status/June-2026/6.jpeg";
import statusImageJun7 from "../../../images/on-going-projects/srinivasa/project-status/June-2026/7.jpeg";

// July
import statusImageJul1 from "../../../images/on-going-projects/srinivasa/project-status/July-2026/1.jpeg";
import statusImageJul2 from "../../../images/on-going-projects/srinivasa/project-status/July-2026/2.jpeg";
import statusImageJul3 from "../../../images/on-going-projects/srinivasa/project-status/July-2026/3.jpeg";
import statusImageJul4 from "../../../images/on-going-projects/srinivasa/project-status/July-2026/4.jpeg";
import statusImageJul5 from "../../../images/on-going-projects/srinivasa/project-status/July-2026/5.jpeg";
import statusImageJul6 from "../../../images/on-going-projects/srinivasa/project-status/July-2026/6.jpeg";
import statusImageJul7 from "../../../images/on-going-projects/srinivasa/project-status/July-2026/7.jpeg";
import statusImageJul8 from "../../../images/on-going-projects/srinivasa/project-status/July-2026/8.jpeg";

// August
import statusImageAug1 from "../../../images/on-going-projects/srinivasa/project-status/august-2026/1.jpeg";
import statusImageAug2 from "../../../images/on-going-projects/srinivasa/project-status/august-2026/2.jpeg";
import statusImageAug3 from "../../../images/on-going-projects/srinivasa/project-status/august-2026/3.jpeg";
import statusImageAug4 from "../../../images/on-going-projects/srinivasa/project-status/august-2026/4.jpeg";
import statusImageAug5 from "../../../images/on-going-projects/srinivasa/project-status/august-2026/5.jpeg";
import statusImageAug6 from "../../../images/on-going-projects/srinivasa/project-status/august-2026/6.jpeg";
import statusImageAug7 from "../../../images/on-going-projects/srinivasa/project-status/august-2026/7.jpeg";
import statusImageAug8 from "../../../images/on-going-projects/srinivasa/project-status/august-2026/8.jpeg";

import bgImage from "../../../images/on-going-projects/srinivasa/header-icon.png";
import ImageModal from "../enchanted/ImageModal";
import { RightCircleFilled, LeftCircleFilled } from '@ant-design/icons';

// Data-driven months config — newest first
const MONTHS = [
  {
    label: 'August',
    images: [statusImageAug1, statusImageAug2, statusImageAug3, statusImageAug4, statusImageAug5, statusImageAug6, statusImageAug7, statusImageAug8],
  },
  {
    label: 'July',
    images: [statusImageJul1, statusImageJul2, statusImageJul3, statusImageJul4, statusImageJul5, statusImageJul6, statusImageJul7, statusImageJul8],
  },
  {
    label: 'June',
    images: [statusImageJun1, statusImageJun2, statusImageJun3, statusImageJun4, statusImageJun5, statusImageJun6, statusImageJun7],
  },
   {
    label: 'May',
    images: [statusImageMay1, statusImageMay2, statusImageMay3, statusImageMay4, statusImageMay5, statusImageMay6, statusImageMay7, statusImageMay8],
  },
  {
    label: 'April',
    images: [statusImageApr1, statusImageApr2, statusImageApr3, statusImageApr4, statusImageApr5],
  },
  {
    label: 'March',
    images: [statusImageMar1, statusImageMar2, statusImageMar3, statusImageMar4, statusImageMar5, statusImageMar6, statusImageMar7, statusImageMar8, statusImageMar9, statusImageMar10],
  },
  {
    label: 'February',
    images: [statusImageFeb1, statusImageFeb2, statusImageFeb3, statusImageFeb4, statusImageFeb5, statusImageFeb6, statusImageFeb7, statusImageFeb8, statusImageFeb9, statusImageFeb10, statusImageFeb11, statusImageFeb12, statusImageFeb13, statusImageFeb14, statusImageFeb15],
  },
  {
    label: 'January',
    images: [statusImageJan1, statusImageJan2, statusImageJan3, statusImageJan4, statusImageJan5, statusImageJan6, statusImageJan7],
  },
  {
    label: 'December',
    images: [statusImageDec1, statusImageDec2, statusImageDec3, statusImageDec4, statusImageDec5, statusImageDec6, statusImageDec7, statusImageDec8, statusImageDec9, statusImageDec10, statusImageDec11, statusImageDec12],
  },
  {
    label: 'November',
    images: [statusImageNov1, statusImageNov2, statusImageNov3, statusImageNov4, statusImageNov5, statusImageNov6, statusImageNov7],
  },
  {
    label: 'September',
    images: [statusImage1, statusImage2, statusImage3, statusImage4, statusImage5, statusImage6],
  },
];

const TOTAL_MONTHS = MONTHS.length; // 7

function ProjectStatus() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeImageMobile, setActiveImageMobile] = useState(0);
  const [activeMonthIndex, setActiveMonthIndex] = useState(0);

  const currentImages = MONTHS[activeMonthIndex].images;

  // Reset mobile slide when month changes
  useEffect(() => {
    setActiveImageMobile(0);
  }, [activeMonthIndex]);

  function prevSlideMobile() {
    if (activeImageMobile > 0) setActiveImageMobile((prev) => prev - 1);
  }

  function nextSlideMobile() {
    if (activeImageMobile < currentImages.length - 1) setActiveImageMobile((prev) => prev + 1);
  }

  function prevSlideMonth() {
    if (activeMonthIndex > 0) setActiveMonthIndex((prev) => prev - 1);
  }

  function nextSlideMonth() {
    if (activeMonthIndex < TOTAL_MONTHS - 1) setActiveMonthIndex((prev) => prev + 1);
  }

  return (
    <div className={styles.projectStatus} id="section-6">
      <div className={styles.heading}>
        <img src={bgImage} alt="Project Status" className={styles.bgImage} />
        <span>Project Status</span>
      </div>

      <div style={{ position: 'relative' }}>
        {/* Mobile image arrows */}
        <LeftCircleFilled
          style={{ opacity: activeImageMobile > 0 ? '1' : '0' }}
          className={styles.arrowMobile + ' ' + styles.arrowMobileLeft}
          onClick={prevSlideMobile}
        />
        <RightCircleFilled
          style={{ opacity: activeImageMobile < currentImages.length - 1 ? '1' : '0' }}
          className={styles.arrowMobile + ' ' + styles.arrowMobileRight}
          onClick={nextSlideMobile}
        />

        {/* Month arrows */}
        <LeftCircleFilled
          style={{ opacity: activeMonthIndex > 0 ? '1' : '0' }}
          className={styles.arrowWeb + ' ' + styles.arrowWebLeft}
          onClick={prevSlideMonth}
        />
        <RightCircleFilled
          style={{ opacity: activeMonthIndex < TOTAL_MONTHS - 1 ? '1' : '0' }}
          className={styles.arrowWeb + ' ' + styles.arrowWebRight}
          onClick={nextSlideMonth}
        />

        <div className={styles.projectStatusContent}>
          {MONTHS.map((month, monthIdx) => (
            <div
              key={month.label}
              className={styles.projectStatusContentItem}
              style={{
                transform: `translateX(${activeMonthIndex * 100 * -1}%)`,
                transition: 'all 0.5s ease',
              }}
            >
              <span className={styles.projectStatusHeading}>{month.label}</span>
              <div className={styles.projectStatusContentContainer}>
                {month.images.map((img, imgIdx) => (
                  <div
                    key={imgIdx}
                    style={{ transform: `translateX(${activeImageMobile * 100 * -1}%)` }}
                    className={styles.projectStatusContentItem}
                  >
                    <img
                      src={img}
                      alt="status-image"
                      onClick={() => {
                        setSelectedImage(imgIdx + 1);
                        setIsModalOpen(true);
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {isModalOpen && (
        <ImageModal
          imagesArray={currentImages}
          selectedImage={selectedImage}
          setSelectedImage={setSelectedImage}
          showModal={isModalOpen}
          setShowModal={setIsModalOpen}
        />
      )}
    </div>
  );
}

export default ProjectStatus;